import { t } from "@redotech/redo-i18n";
import BuildingIcon from "@redotech/redo-icons/building-02.svg";
import { Step } from "@redotech/redo-return-core-common/return-flow";
import { redoManagedLocationFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isRedoManagedLocationStepValid,
  RedoManagedLocationState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";

import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { ReturnProcessingLevel } from "@redotech/redo-return-settings-primitives-common/return-processing-level";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const REDO_MANAGED_LOCATION = (
  Details: React.ComponentType<StepTypeDetailsProps<RedoManagedLocationState>>,
): StepType<RedoManagedLocationState, Step.RedoManagedLocation> => ({
  layout() {
    return BlockLayout.FULL;
  },

  empty: {
    returnsCenterIds: [],
    serviceLevel: ReturnProcessingLevel.VERIFICATION,
    refulfillmentEnabled: false,
  },

  title: STEP_TYPE_NAMES[Step.REDO_MANAGED_LOCATION],

  customTitle: (state) => state.customTitle,

  description: (state) => {
    const count = state.returnsCenterIds?.length ?? 0;
    if (count === 0) {
      return t("No center selected");
    }
    return t("{{count}} centers", { count });
  },

  Icon: BuildingIcon,
  iconColor: "success",

  Details(props) {
    return <Details {...props} />;
  },

  downstream: () => [],

  maxDownstream: () => 0,

  fromModel: (model) => redoManagedLocationFromModel(model),

  toModel: (state, _id) => ({
    type: Step.REDO_MANAGED_LOCATION,
    customTitle: state.customTitle,
    returnsCenterIds: state.returnsCenterIds,
    serviceLevel: state.serviceLevel,
    refulfillmentEnabled: state.refulfillmentEnabled,
    processingFee: state.processingFee,
    consolidationScheduleDays: state.consolidationScheduleDays,
    rateSourceSelection: state.rateSourceSelection,
  }),

  valid: (state) => isRedoManagedLocationStepValid(state).valid,

  stepDeleted: (state) => state,
});
